import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { loginRoutingModule } from './login-routing.module'
import { LoginComponent } from './login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NxInputModule } from '@allianz/ng-aquila/input';
import { NxFormfieldModule } from '@allianz/ng-aquila/formfield';
import { NxGridModule } from '@allianz/ng-aquila/grid';
import { NxLabelModule, NxErrorModule } from '@allianz/ng-aquila/base';
import { NxCardModule } from '@allianz/ng-aquila/card';
import { NxButtonModule } from '@allianz/ng-aquila/button';
import { NxLinkModule } from '@allianz/ng-aquila/link';
import { NxHeaderModule } from '@allianz/ng-aquila/header'
import { NxImageModule } from '@allianz/ng-aquila/image';
import { NxIconModule } from '@allianz/ng-aquila/icon';
import { NxMessageModule } from '@allianz/ng-aquila/message';
import { TitleModule } from '../title/title.module';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';
import { NxModalModule } from '@allianz/ng-aquila/modal';
import { NxSmallStageModule } from '@allianz/ng-aquila/small-stage';
import { ForgotpasswordComponent } from '../forgotpassword/forgotpassword.component';

@NgModule({
  declarations: [
    LoginComponent,
    ForgotpasswordComponent,
  ],
  imports: [
    CommonModule,
    loginRoutingModule,
    NxInputModule,
    NxFormfieldModule,
    FormsModule,
    ReactiveFormsModule,
    NxGridModule,
    NxLabelModule,
    NxErrorModule,
    NxCardModule,
    NxButtonModule,
    NxLinkModule,
    NxHeaderModule,
    NxImageModule,
    NxIconModule,
    NxMessageModule,
    TitleModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    NxModalModule,
    NxSmallStageModule
  ],
  exports: [LoginComponent, ForgotpasswordComponent]
})
export class LoginModule { }
